module.exports = __webpack_public_path__ + "img/vertical-red-line-long.e6644ca3.svg";